module.exports = __webpack_public_path__ + "r-v3/img/wonder.1df5b735.svg";